export interface CalculatorInputs {
  numberOfTeams: number
  avgTeamSize: number
  meetingsPerWeek: number
  minutesPerMeeting: number
  hourlyRate: number
  attendanceRate?: number
  overrunFactor?: number
  opportunityCostMultiplier?: number
}

export function calculateAnnualWaste(inputs: CalculatorInputs): number {
  const {
    numberOfTeams,
    avgTeamSize,
    meetingsPerWeek,
    minutesPerMeeting,
    hourlyRate,
    attendanceRate = 1,
    overrunFactor = 1,
    opportunityCostMultiplier = 1,
  } = inputs

  const totalPeople = numberOfTeams * avgTeamSize
  const hoursPerMeeting = (minutesPerMeeting / 60) * overrunFactor
  const weeksPerYear = 48 // take into account 20 days of vacation per year = 4 weeks

  const annualWaste =
    totalPeople *
    attendanceRate *
    meetingsPerWeek *
    hoursPerMeeting *
    weeksPerYear *
    hourlyRate *
    opportunityCostMultiplier

  return Math.round(annualWaste)
}

export function getComparisonMetrics(amount: number) {
  return {
    macbookPros: Math.floor(amount / 3000),
    teslaModel3s: (amount / 40000).toFixed(1),
    engineerMonths: Math.floor(amount / 25000),
    yCombinatorsEquity: Math.floor(amount / 125000),
  }
}
